import i18n from '@i18next/i18n';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Button from '@tencent/dui/lib/components/Button';
import React from 'react';
import SYNC_IMAGE from '@tencent/docs-design-resources/icon/desktop/svg/upload_outline_heavy_24.svg';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import classNames from 'classnames';
import Style from './index.less';
import { EditEvents } from '@src/slide/domain/slide-app/core/interfaces/event.interface';

interface ILocalSyncState {
    shouldRender: boolean;
    shouldShowSyncBtn: boolean;
}

export default class LocalSync extends React.Component<{}, ILocalSyncState> {
    public constructor(props) {
        super(props);
        this.state = {
            shouldRender: true,
            shouldShowSyncBtn: !!SlideDataServices.DocInfoManager()?.cGlobalPadId,
        };

        this.registerEvent();
    }

    public render() {
        return this.state.shouldRender ? (
            <React.Fragment>
                { this.state.shouldShowSyncBtn
                    ? <Tooltip
                        placement="bottom"
                        title={i18n.t('同步')}
                        className={Style['local-file-sync-tooltip']}
                    >
                        <div
                            className={
                                classNames(
                                    Style['local-file-sync'],
                                    {
                                        [Style['local-file-sync-disabled']]: false,
                                    },
                                )}
                            onClick={this.onClickSync}
                        >
                            <img src={SYNC_IMAGE} />
                        </div>
                    </Tooltip>
                    : <Button className={Style['create-sync-doc']} type="primary" size="small" onClick={this.createCloudDoc}>{ i18n.t('转为同步盘文档') }</Button>
                }
            </React.Fragment>
        ) : null;
    }


    private registerEvent() {
        SlideDataServices.EventManager.promise().then((editEvent) => {
            editEvent.on(EditEvents.ClientVarChanged, () => {
                const shouldShowSyncBtn = !!SlideDataServices.DocInfoManager()?.cGlobalPadId;
                this.setState({ shouldShowSyncBtn });
            });
        });
    }

    private createCloudDoc = async () => {
        const syncManager = await SlideDataServices.SyncManager.promise();
        await syncManager.createDoc();
    };

    private onClickSync = async () => {
        const syncManager = await SlideDataServices.SyncManager.promise();
        await syncManager.syncDoc();
    };
}

